import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=bc0b2b6e&scoped=true"
var script = {}
import style0 from "./Paging.vue?vue&type=style&index=0&id=bc0b2b6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0b2b6e",
  null
  
)

export default component.exports